<template>
    <dg-field-container :label_span="label_span" :field_span="field_span" :field_mark="field_mark"
         :field_validate_message="validateMessage" v-if="amReady">
        <template v-slot:label>
            <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
        </template>
        <template v-slot:field>
          <div v-if="editable">
            <el-select :size="fieldSize" v-model="field_value" @change="updateValue" :disabled="disabled" :filterable="filterable || allowCreate" :placeholder="placeholder"
           :allow-create="allowCreate" :multiple="multiple || allowCreate" :default-first-option="defaultFirstOption || allowCreate" class="w-100">
                <el-option v-for="item in options" :key="item[valueProperty]" :value="item[valueProperty]"
                    :label="(translateLabels)?$ml.get(item[labelProperty]): item[labelProperty]">
                </el-option>
            </el-select>
            <slot name="field_note"></slot>
          </div>
          <div v-else>
            <dg-label-field  v-if="field_value && field_value.constructor !== Array" :label="bindingValues[field_value][labelProperty]" :translate="false"></dg-label-field>
            <div v-else-if="field_value && field_value.constructor == Array">
              <dg-label-field v-for="(value, valueKey) in field_value"  :label="value" :translate="false" :key="valueKey"></dg-label-field>
            </div>
          </div>
        </template>
    </dg-field-container>
</template>

<script>
import inputField from '../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    options: {
      required: true,
      type: Array
    },
    filterable: {
      required: false,
      default: true
    },
    translateLabels: {
      required: false,
      default: true
    },
    labelProperty: {
      required: false,
      default: 'label'
    },
    valueProperty: {
      required: false,
      default: 'value'
    },
    allowCreate: {
      required: false,
      default: false
    },
    multiple: {
      required: false,
      default: false
    },
    defaultFirstOption: {
      required: false,
      default: false
    }
  },
  watch: {options(val) {this.setBindingValues(val)}},
  methods: {
    setBindingValues (options) {
      let bindingValues = {};
      for (let x in options) {
        bindingValues[options[x][this.valueProperty]] = options[x];
      }
      this.bindingValues = bindingValues
    }
  },
  mounted() {
    this.setBindingValues(this.options)
    this.amReady = true
    if (this.onMounted) { this.onMounted(this, this.onMountedProps)}
  },
  data () {
    return {
      field_value: null,
      binding: 'select',
      bindingValues: {},
      amReady: false
    }
  }
}
</script>
